export const DEFAULT_TAG_SIZE = "20";

export const TAG_SIZE_TO_COUNTER_SIZE = {
    [DEFAULT_TAG_SIZE]: "8",
    "24": "8",
    "32": "8",
};

export const TAG_SIZE_TO_ASSET_SIZE = {
    [DEFAULT_TAG_SIZE]: "16",
    "24": "16",
    "32": "16",
};

export const ASSET_SIZE_TO_TAG_SIZE = {
    "16": [DEFAULT_TAG_SIZE, "24", "32"],
};
